/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * DatePicker body styles
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components'

import { colors } from '../../../../../theme';
import { IAttrStyled } from '../../../../../types/globalTypes';
import { DatePickerCellStyled } from '../DatePickerStyled';

/*
* -------------------------------------------
*           Cells
* -------------------------------------------
*/

export const DatePickerBodyCellStyled = styled(DatePickerCellStyled).attrs((props: IAttrStyled) => ({
    className: `date-picker__body-cell ${props.className || ''}`,
}))<IAttrStyled>`
    border-radius: 16px;
    cursor: pointer;

    &.available:hover {
        background-color: ${colors.backgroundColorHoverOpacity};
    }

    &.selected {
        color: ${colors.backgroundColorWhite};
        background-color: ${colors.backgroundColorSuccess};
        &:hover {
            background-color: ${colors.backgroundColorHoverGreen};
        }
    }

    &.invisible {
        visibility: hidden;
    }

    &.disabled {
        cursor: auto;
        pointer-events: none;
        color: ${colors.borderColorSeparate};
    }
`
